var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": { maxWidth: _vm.getMaxWidth, minWidth: _vm.getMinWidth },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_preview,
        callback: function($$v) {
          _vm.show_preview = $$v
        },
        expression: "show_preview"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_preview = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t(_vm.game_name)) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "row q-pa-xs" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("p", { staticClass: "text-bold" }, [
                    _vm._v(_vm._s(_vm.$t("game_preview")))
                  ]),
                  _vm._l(_vm.game_words, function(word, index) {
                    return _c(
                      "span",
                      { key: index },
                      [
                        _vm.userOption(word, index)
                          ? _c(
                              "q-chip",
                              {
                                staticClass:
                                  "word-field font-bigger text-white bg-primary q-ma-xs cursor-pointer",
                                attrs: {
                                  square: "",
                                  removable: "",
                                  id: "chip-" + index
                                },
                                on: {
                                  click: function($event) {
                                    !_vm.game_finished
                                      ? _vm.removeWord(word, index)
                                      : null
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(word + " ") +
                                    "\n                            "
                                ),
                                !_vm.game_finished
                                  ? _c("q-icon", {
                                      staticClass: "q-pl-sm",
                                      staticStyle: { "font-size": "0.8rem" },
                                      attrs: { name: "fas fa-times" }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : word !== "SPECIAL_WORD" && word.includes("\n")
                          ? _c("span", { staticClass: "font-bigger" }, [
                              _c("br"),
                              _vm._v(_vm._s(word + " "))
                            ])
                          : word !== "SPECIAL_WORD"
                          ? _c("span", { staticClass: "font-bigger" }, [
                              _vm._v(_vm._s(word + " "))
                            ])
                          : _c(
                              "q-chip",
                              {
                                staticClass: "word-field font-bigger q-ma-xs",
                                attrs: { square: "" },
                                nativeOn: {
                                  drop: function($event) {
                                    return _vm.onDropWord(index)
                                  },
                                  dragover: function($event) {
                                    return _vm.dragOverWord.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.mapChoices(word, index)) +
                                    "\n                        "
                                )
                              ]
                            )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm.game_finished
                ? _c(
                    "div",
                    { staticClass: "col-10 q-mt-lg" },
                    [
                      _c("p", { staticClass: "text-bold q-mt-sm" }, [
                        _vm._v(_vm._s(_vm.$t("result")))
                      ]),
                      _c("q-slider", {
                        attrs: {
                          disable: "",
                          markers: "",
                          snap: "",
                          color: _vm.game_finished
                            ? _vm.getSliderColor()
                            : "blue-6",
                          min: 0,
                          max: _vm.number_of_choices
                        },
                        model: {
                          value: _vm.user_score,
                          callback: function($$v) {
                            _vm.user_score = $$v
                          },
                          expression: "user_score"
                        }
                      }),
                      _c("p", { staticClass: "q-mt-sm" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("correct_answers") +
                              ": " +
                              _vm.user_score +
                              " / " +
                              _vm.number_of_choices
                          )
                        )
                      ]),
                      _vm.user_won
                        ? _c("p", [_vm._v(_vm._s(_vm.$t(_vm.success_message)))])
                        : _c("p", [_vm._v(_vm._s(_vm.$t(_vm.failure_message)))])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm.options.length
              ? _c(
                  "div",
                  { staticClass: "col-xs-12 q-mt-lg q-ma-sm shadow-2 q-pa-md" },
                  [
                    _c("p", { staticClass: "text-bold" }, [
                      _vm._v(_vm._s(_vm.$t("words")))
                    ]),
                    _vm._l(_vm.options, function(opt, index) {
                      return _c(
                        "span",
                        { key: index + "o", staticClass: "q-my-sm q-mr-sm" },
                        [
                          _c(
                            "q-chip",
                            {
                              staticClass: "word-options font-bigger q-ma-xs",
                              attrs: {
                                square: "",
                                color: "primary",
                                "text-color": "white",
                                draggable: "true"
                              },
                              nativeOn: {
                                dragstart: function($event) {
                                  return _vm.dragStart(opt.text)
                                }
                              }
                            },
                            [_vm._v(_vm._s(opt.text))]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _c("div", { staticClass: "col-xs-12 q-mt-md" }, [
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("back") },
                    on: {
                      click: function($event) {
                        _vm.show_preview = false
                      }
                    }
                  }),
                  !_vm.options.length
                    ? _c("q-btn", {
                        staticClass: "q-ml-md",
                        attrs: {
                          color: "primary",
                          label: _vm.$t("play_again")
                        },
                        on: { click: _vm.resetGame }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }